export default "__VITE_ASSET__CFjydmxX__"